import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { confirmAndLogout } from '../utils/session';
import { useAuth } from '../context/authContext';
import { apiFetch } from '../api/setupAxios';
import axios from 'axios';

const Admin = () => {
  const navigate = useNavigate();
  const { user: authUser } = useAuth();
  const rolActual = authUser?.tipo || '';
  const esCompras   = rolActual === 'admin_compras' || rolActual === 'superadmin';
  const esServicios = rolActual === 'admin_servicios' || rolActual === 'admin_asistentas' || rolActual === 'admin_atcliente' || rolActual === 'superadmin';
  const esAsistentas = rolActual === 'admin_servicios' || rolActual === 'admin_asistentas' || rolActual === 'superadmin';
  const esAtCliente  = rolActual === 'admin_servicios' || rolActual === 'admin_atcliente'  || rolActual === 'superadmin';
  // "Mis Supervisoras" (ver/gestionar encargadas): admin_asistentas, admin_atcliente y admin_servicios.
  const esEncargadas = rolActual === 'admin_asistentas' || rolActual === 'admin_atcliente' || rolActual === 'admin_servicios';
  // Reporte de Supervisoras: el backend (reporte_supervisoras_panel.py) solo admite estos dos, no admin_servicios.
  const esEncargadasReporte = rolActual === 'admin_asistentas' || rolActual === 'admin_atcliente';
  const esSuperAdmin = rolActual === 'superadmin';
  const [notifsEnabled, setNotifsEnabled] = useState(false);
  // "Ver ruta supervisora" solo se muestra a un encargado si tiene al
  // menos una supervisora asignada (admin_supervisoras_encargadas); a
  // diferencia de "Mis Supervisoras", que se muestra siempre (esa pantalla
  // ya gestiona por sí sola el caso de 0 asignadas).
  const [tieneSupervisorasAsignadas, setTieneSupervisorasAsignadas] = useState(false);

  const [showDevices, setShowDevices] = useState(false);
  const [devices, setDevices] = useState([]);

  // small toast helper
  const showToast = (msg, duration = 3000) => {
    const el = document.createElement('div');
    el.textContent = msg;
    Object.assign(el.style, {
      position: 'fixed', bottom: 20, left: '50%', transform: 'translateX(-50%)', background: 'rgba(0,0,0,0.8)', color: '#fff', padding: '10px 14px', borderRadius: 6, zIndex: 9999
    });
    document.body.appendChild(el);
    setTimeout(() => { el.remove(); }, duration);
  };

  useEffect(() => {
    try {
      const stored = sessionStorage.getItem('enAdmin_notifs');
      setNotifsEnabled(stored === '1');
    } catch (_) {}
  }, []);

  const toggleNotifs = () => {
    try {
      const next = !notifsEnabled;
      sessionStorage.setItem('enAdmin_notifs', next ? '1' : '0');
      setNotifsEnabled(next);
    } catch (_) { setNotifsEnabled(s => !s); }
  };

  const handleToggleNotifs = () => {
    const next = !notifsEnabled;
    const pregunta = next ? '🔔 ¿Habilitar notificaciones? 🔔' : '🔕 ¿Deshabilitar notificaciones? 🔕';
    const confirmar = window.confirm(pregunta);
    if (!confirmar) return;
    try { sessionStorage.setItem('enAdmin_notifs', next ? '1' : '0'); setNotifsEnabled(next); } catch (_) { setNotifsEnabled(s=>!s); }
  };

  const handleLogout = () => {
    confirmAndLogout(navigate, '/login');
  };

  const sendTest = async () => {
    try {
      const user = getUserString();
      const r = await apiFetch('/device-notifs/send-test', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' , 'X-User': user || ''},
        credentials: 'include',
        body: JSON.stringify({ user, title: 'Prueba desde app', body: 'Mensaje de prueba' }),
      });
      const j = await r.json();
      if (j.ok) showToast('Envio de prueba iniciado');
      else showToast('Error al enviar prueba: ' + (j.error || ''));
    } catch (e) { showToast('Error enviando prueba'); }
  };

  useEffect(() => {
    if (showDevices) fetchDevices();
  }, [showDevices]);

    // fetch and revoke helpers for the devices modal
  const fetchDevices = async () => {
    try {
      // request ALL devices from the DB so the modal shows every row (admin view)
      const url = '/device-notifs/devices?all=1';
      // prefer explicit session token if available (saved at login)
      const tok = getSessionToken();
      const user = (tok && tok.user) ? tok.user : getUserString();
      const headers = {};
      if (user) headers['X-User'] = user;
      const r = await apiFetch(url, { credentials: 'include', headers });
          const j = await r.json();
          if (j.ok) setDevices(j.devices || []);
          else showToast('No se pudieron cargar dispositivos');
        } catch (e) {
          console.error('fetchDevices', e);
          showToast('Error cargando dispositivos');
      }
  };

  const revokeDevice = async (device_id) => {
    try {
      const user = getUserString();
      const r = await apiFetch('/device-notifs/revoke', { method: 'POST', headers: {'Content-Type':'application/json'}, credentials: 'include', body: JSON.stringify({ device_id, user }) });
      const j = await r.json();
      if (j.ok) { setDevices(d => d.filter(x => x.device_id !== device_id)); showToast('Dispositivo revocado'); }
      else showToast('Error revocando');
    } catch (e) { console.error('revokeDevice', e); showToast('Error revocando'); }
  };

  // device id: persisted in localStorage so it's unique per browser/device
  const getDeviceId = () => {
    try {
      // prefer token-stored device_id if present
  const tokRaw = localStorage.getItem('session_token');
      if (tokRaw) {
        try {
          const tok = JSON.parse(tokRaw) || {};
          if (tok.device_id) return tok.device_id + '';
        } catch (_) {}
      }
      let id = localStorage.getItem('device_id');
      if (!id) {
        // simple random id; crypto.randomUUID if available
        id = (typeof crypto !== 'undefined' && crypto.randomUUID) ? crypto.randomUUID() : Math.random().toString(36).slice(2, 10);
        localStorage.setItem('device_id', id);
      }
      return id;
    } catch (e) {
      return 'unknown-device';
    }
  };

  // session token helpers: store a JSON token with user and device_id
  const getSessionToken = () => {
    try {
  const raw = localStorage.getItem('session_token');
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (_) { return null; }
  };

  // read a simple user identifier saved by Login (sessionStorage or localStorage)
  const getUserString = () => {
    try {
      const s = sessionStorage.getItem('user') || localStorage.getItem('user') || '';
      if (!s) return '';
      // sometimes Login stores a JSON object; try parse and extract common fields
      try {
        const o = JSON.parse(s);
        return (o.user || o.id || o.email || o.usuario || o.username || '') + '';
      } catch (_) {
        return s + '';
      }
    } catch (_) { return ''; }
  };

  useEffect(() => {
    const handlePopState = () => {
      if (rolActual === 'superadmin') {
        navigate('/superadmin');
      } else {
        const didLogout = confirmAndLogout(navigate, '/login');
        if (!didLogout) {
          try { window.history.pushState(null, '', window.location.href); } catch(_) {}
        }
      }
    };

    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handlePopState);

    return () => window.removeEventListener('popstate', handlePopState);
  }, [navigate, rolActual]);

  useEffect(() => {
    if (!esEncargadas) return;
    axios.get('/api/seguimiento-supervisoras/mis-supervisoras')
      .then((r) => setTieneSupervisorasAsignadas((r.data?.supervisoras || []).length > 0))
      .catch(() => setTieneSupervisorasAsignadas(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [esEncargadas]);

  const options = [
    // --- COMPRAS ---
    { title: 'Ver Compras', image: '/images/estadoCompras.png', path: '/admin/verCompras', visible: esCompras },
    { title: 'Seguimiento Repartidores', image: '/images/seguimiento_repartidores.png', path: '/admin/seguimiento-repartidores', visible: esCompras },
    { title: 'Seguimiento Compradores', image: '/images/seguimiento_compradores.png', path: '/admin/seguimiento-compradores', visible: esCompras },
    { title: 'Panel de Descargas', image: '/images/descargas.png', path: '/admin/descargas', visible: esCompras },
    { title: 'Calendario limpiezas', image: '/images/calendario-limpiezas.jpg', path: '/admin/calendario-limpiezas', visible: esCompras },
    { title: 'Gestión de Productos', image: '/images/gestion_productos.png', path: '/admin/productos', visible: esCompras },
    { title: 'Gestión de Pisos', image: '/images/gestion_pisos.png', path: '/admin/pisos', visible: esCompras || esServicios },
    { title: 'Gestión de Alumnos', image: '/images/gestion_usuarios.png', path: '/admin/alumnos', visible: esAtCliente },
    { title: 'Seguimiento Servicios', image: '/images/seguimiento-servicios.jpg', path: '/admin/seguimientoServicios', visible: esAsistentas },
    { title: 'Mis Supervisoras', image: '/images/mis-supervisoras.png', path: `/admin/encargadas/${getUserString()}`, visible: esEncargadas },
    { title: 'Ruta de supervisora', image: '/images/ver-ruta-supervisora.png', path: '/admin/ruta-supervisora', visible: esSuperAdmin || esEncargadasReporte },
    { title: 'Sustituciones', image: '/images/sustituciones.png', path: '/admin/sustituciones', visible: rolActual === 'admin_asistentas' },
    { title: 'Análisis Asistentas', image: '/images/estadisticas.png', path: '/admin/analisis-asistentas', visible: esAsistentas || esAtCliente },
    { title: 'Análisis Supervisoras', image: '/images/estadisticas.png', path: '/admin/analisis-supervisoras', visible: esAsistentas || esAtCliente },
    { title: 'Estado de Pisos', image: '/images/estadisticas.png', path: '/admin/analisis-pisos', visible: esAsistentas || esAtCliente },
    { title: 'Análisis Alumnos', image: '/images/gestion_usuarios.png', path: '/admin/analisis-alumnos', visible: esAsistentas || esAtCliente },
    { title: 'Reportes Diarios', image: '/images/reporte-asistentas.jpg', path: '/admin/reportes-diarios', visible: esAsistentas || esAtCliente },
    { title: 'Reporte de Asistentas', image: '/images/reporte-asistentas.jpg', path: '/admin/reporte-asistentas', visible: esSuperAdmin || rolActual === 'admin_asistentas' || (esEncargadas && tieneSupervisorasAsignadas) },
    { title: 'Reporte de Supervisoras', image: '/images/mis-reportes.png', path: '/admin/reporte-supervisoras', visible: esSuperAdmin || esEncargadasReporte },
    { title: 'Organización Ruta 3', image: '/images/organizar-servicios.png', path: '/admin/organizar-ruta-3', visible: esSuperAdmin || esEncargadasReporte },
    { title: 'Configuración Servicios', image: '/images/configuracion.png', path: '/admin/configuracion-servicios', visible: esAsistentas },
    // --- COMÚN ---
    { title: 'Gestión de Usuarios', image: '/images/gestion_usuarios.png', path: '/admin/usuarios', visible: esCompras || esServicios },
    // --- SOLO SUPER ADMIN ---
    { title: 'Ver Gastos', image: '/images/prestamos.png', path: '/admin/gastos', visible: esSuperAdmin },
  ].filter((o) => o.visible);
  // admin_asistentas: orden propio de sus botones (los que no estén en la lista van detrás)
  if (rolActual === 'admin_asistentas') {
    const ORDEN = ['Ruta de supervisora', 'Reporte de Asistentas', 'Reporte de Supervisoras', 'Sustituciones', 'Gestión de Usuarios', 'Mis Supervisoras'];
    const pos = (o) => { const i = ORDEN.indexOf(o.title); return i === -1 ? ORDEN.length : i; };
    options.sort((a, b) => pos(a) - pos(b));
  }

  return (
    <div style={{ ...styles.container, position: 'relative' }}>
      <div style={{ position: 'absolute', top: 12, left: 12, right: 12, display: 'flex', justifyContent: esSuperAdmin ? 'space-between' : 'flex-end', alignItems: 'center', zIndex: 50 }}>
        {esSuperAdmin && (
          <button
            onClick={() => navigate('/superadmin')}
            style={{
              padding: '12px 16px',
              borderRadius: 10,
              backgroundColor: '#3b82f6',
              color: '#fff',
              border: 'none',
              cursor: 'pointer',
              fontWeight: 800,
              fontSize: 15,
            }}
          >
            ← Volver
          </button>
        )}
        <button
          onClick={handleLogout}
          style={{
            padding: '12px 16px',
            borderRadius: 10,
            backgroundColor: '#ef4444',
            color: '#fff',
            border: 'none',
            cursor: 'pointer',
            fontWeight: 800,
            fontSize: 15,
          }}
          title="Cerrar sesión"
        >
          Cerrar sesión
        </button>
      </div>

      <h1 style={styles.title}>Panel de Administrador de <strong style={{ color: "#007bff" }}>{getUserString()}</strong></h1>
      <div style={styles.buttonContainer}>
        {options.map((option) => (
          <button key={option.title} onClick={() => navigate(option.path)} style={styles.button}>
            <img src={option.image} alt={option.title} style={styles.image} onError={(e) => { if (!e.currentTarget.dataset.fallback) { e.currentTarget.dataset.fallback = "1"; e.currentTarget.src = "/images/estadoCompras.png"; } }} />
            <span style={styles.label}>{option.title}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    textAlign: 'center',
    padding: '40px',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  title: {
    marginBottom: '30px',
    color: '#333',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    alignItems: 'center',
  },
  button: {
    backgroundColor: 'transparent',
    width: '90%',
    maxWidth: '400px',
    padding: '20px',
    border: '2px solid #007bff',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '20px',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
  },
  image: {
    width: '50px',
    height: '50px',
    objectFit: 'contain',
  },
  label: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#007bff',
    textAlign: 'center',
  },
};

export default Admin;
